(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pmp-live-badge"] && !Shopify.designMode) return;
  try {
    function setupPmpLiveBadge(){
const badge=document.getElementById('pmp-live-badge');
if(!badge)return;
const key='pmp-live-dismissed:'+badge.querySelector('a').href;
try{if(sessionStorage.getItem(key))badge.hidden=true;}catch(e){}
badge.querySelector('button').addEventListener('click',()=>{badge.hidden=true;try{sessionStorage.setItem(key,'1');}catch(e){}});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',setupPmpLiveBadge);}else{setupPmpLiveBadge();}
document.addEventListener('shopify:section:load',setupPmpLiveBadge);
  } catch(e) { console.error(e); }
})();

})();
